"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IOAutoTestStep = void 0;
const utils_1 = require("@/utils");
const base_1 = require("./base");
const utils_2 = require("./utils");
class IOAutoTestStep extends base_1.BaseAutoTestStep {
    parseInputData(data) {
        return data;
    }
    getDataToSave() {
        const errs = this._checkProgramNotEmpty();
        if (this.data.inputs.length === 0) {
            errs.push('There should be at least one input output case.');
        }
        else {
            this.data.inputs.forEach((input, i) => {
                const name = `${(0, utils_1.withOrdinalSuffix)(i + 1)} input output case`;
                if ((0, utils_2.isEmpty)(input.name)) {
                    errs.push(`The name of the ${name} is empty.`);
                }
                if (Number(input.weight) < 0) {
                    errs.push(`The weight of the ${name} should not be negative.`);
                }
            });
        }
        return (0, utils_2.mergeEithers)(this._baseGetDataToSave(), (0, utils_2.errOrData)(errs, { data: this.data, type: this.type }));
    }
}
exports.IOAutoTestStep = IOAutoTestStep;
